<template>
  <div>
    <Back/>
    <Headshot/>
    <Name/>
    <Address/>
    <About_Text/>
    <Social/>
  </div>
</template>

<script>

    import Back from './views/back.vue';
    import Headshot from './views/headshot.vue';
    import Name from './views/name.vue';
    import Address from './views/address.vue';
    import About_Text from './views/about-text.vue';
    import Social from './views/social.vue';

    export default {
      name: 'About',
      props: {
        msg: String
      },
      components: {
        Back,
        Headshot,
        Name,
        Address,
        About_Text,
        Social
      }
    }
    
</script>

<style scoped>
</style>
